module.exports = __webpack_public_path__ + "img/ClickForSound_15.25cf04cf.png";